/**
 * 유료 전용 안내 모달 — usePaidModalStore 로 어디서나 호출.
 * AppShell 에 1회 마운트. 무료 사용자가 잠긴 동작 클릭 시 표시.
 */
import { useNavigate } from 'react-router-dom'
import { FiLock } from 'react-icons/fi'
import { usePaidModalStore } from '../../store/paidModalStore'

export default function PaidFeatureModal() {
  const navigate = useNavigate()
  const { isOpen, title, message, close } = usePaidModalStore()
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/55 backdrop-blur-sm p-4"
         onClick={close}>
      <div className="w-full max-w-sm rounded-2xl bg-surface-card border border-surface-elevated/40 shadow-2xl p-7 text-center"
           onClick={(e) => e.stopPropagation()}>
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/15">
          <FiLock className="text-amber-500" size={26} />
        </div>
        <h2 className="text-lg font-bold text-ink mb-2">{title}</h2>
        <p className="text-sm text-ink-muted leading-relaxed mb-6 whitespace-pre-line">{message}</p>
        <button
          onClick={() => { close(); navigate('/dashboard/billing') }}
          className="w-full mb-2 rounded-xl bg-brand-primary hover:bg-brand-primary-dark text-white font-semibold py-3 transition-colors"
        >
          플랜 업그레이드
        </button>
        <button
          onClick={close}
          className="w-full rounded-xl border border-surface-elevated/60 text-ink-muted hover:text-ink font-medium py-2.5 text-sm transition-colors"
        >
          닫기
        </button>
      </div>
    </div>
  )
}
